import {useDebugValue} from 'react';

import classNames from 'classnames';

import {useSearchFormContext} from '../../../hooks/useSearchFormContext';

const classNamespace = 'search-form';
const datesPickerModalTitleClassName = `${classNamespace}__dates-picker-modal-title`;

function useComponent() {
    const {
        systemOptions: {
            locale
        },
        datesOptions: {
            dateFormatOptions
        },
        datesSettings: {
            isSelecting
        },
        datesTranslations: {
            startDateLabel,
            endDateLabel
        },
        latestDatesValues: {
            startDate,
            endDate
        }
    } = useSearchFormContext();

    const className = classNames(datesPickerModalTitleClassName);

    const result = {
        className,
        locale,
        startLabel: startDateLabel,
        endLabel: endDateLabel,
        startDate,
        endDate,
        dateFormatOptions,
        isSelecting
    };

    useDebugValue(result);

    return result;
}

export {useComponent};
